import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=547a650a&scoped=true&"
import script from "./ShippingAddress.vue?vue&type=script&lang=ts&"
export * from "./ShippingAddress.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingAddress.vue?vue&type=style&index=0&id=547a650a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a650a",
  null
  
)

export default component.exports